import { type IValidatedResponse, postRequest } from '../../httpClient';
import type { IGetBookmarkStatusBatchV1Request } from './get-bookmark-status-batch-v1-request';
import {
  getBookmarkStatusBatchV1ResponseSchema,
  type IGetBookmarkStatusBatchV1Response,
} from './get-bookmark-status-batch-v1-response';

export async function getBookmarkStatusBatchV1Api({
  challengeIds,
}: IGetBookmarkStatusBatchV1Request): Promise<
  IValidatedResponse<IGetBookmarkStatusBatchV1Response>
> {
  return postRequest<IGetBookmarkStatusBatchV1Response>({
    path: '/bookmarks/status/v1',
    body: { challengeIds },
    schema: getBookmarkStatusBatchV1ResponseSchema,
  });
}
